import React, { useState } from 'react'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { logo, logoTitle, mobileLogo, viewMenu } from 'images'
import ViewMenu from './ViewMenu'
import { dispatch } from 'store'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/8GFwb8UTNOQ2rbtqc9kk/locations/Y7GXtSFgqD6z5v9Jpd8q'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView column center w="100%" bg="#A00F0F">
          <CFImage w="75%" src={mobileLogo} alt="Hanabi Sushi Logo" mt="5px" />
          <CFView>
            <CFView
              center
              br="40px"
              bc="white"
              bw="3px"
              pv="5px"
              ph="15px"
              mv="10px"
            >
              <CFView color="white" raleway xBold style={{ fontSize: 19 }}>
                BATTLEFORD
              </CFView>
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          row
          justifyBetween
          alignCenter
          w="100%"
          zIndex={98}
          bg="#A00F0F"
          h="60px"
        >
          <CFImage
            ml="50px"
            w="32%"
            maxWidth="430px"
            src={logo}
            alt="Hanabi Sushi Logo"
            zIndex={98}
          />
          <CFView mr="15px">
            <ViewMenu />
          </CFView>
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}
